import { eventManager } from "@/eventManager.js";

const sessionStorageTokenKey = 'token';
const sessionStorageNameKey = 'signed-in-user';
const sessionStateChangedEventName = 'session-state-changed';

const session = {
  setSession(token, user) {
    window.sessionStorage.setItem(sessionStorageTokenKey, token);
    if (user) {
      window.sessionStorage.setItem(sessionStorageNameKey, JSON.stringify(user));
    }

    eventManager.$emit(sessionStateChangedEventName);
  },

  getToken() {
    return window.sessionStorage.getItem(sessionStorageTokenKey);
  },

  getSignedInUser() {
    const signedInUser = window.sessionStorage.getItem(sessionStorageNameKey);
    if (signedInUser) {
      return JSON.parse(signedInUser);
    }
  },

  clear() {
    window.sessionStorage.removeItem(sessionStorageTokenKey);
    window.sessionStorage.removeItem(sessionStorageNameKey);

    eventManager.$emit(sessionStateChangedEventName);
  },

  isValid() {
    if (window.sessionStorage.getItem(sessionStorageTokenKey)) {
      return true;
    }

    return false;
  }
}

export default session;
